import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { MonthlyCutoffDataType } from "../../../types";
import { getPreviousMonthYear, formatDate } from "../../../utils/date";
import { formatNumberWithCommas } from "../../../utils/numbers";

type GenerateProps = {
  meterSerialNo: string;
  results: MonthlyCutoffDataType[];
  showLiters: boolean;
};

function formatVolume(value: number | null | undefined, showLiters: boolean): string {
  if (value === null || value === undefined) return "--";
  if (showLiters) return formatNumberWithCommas(Math.round(value));
  const truncated = Math.trunc(value / 10) / 100;
  return formatNumberWithCommas(truncated);
}

export default function generateMonthlyCutoffsPdf({ meterSerialNo, results, showLiters }: GenerateProps) {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  // Top-right header: title
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Monthly Consumption Report", pageWidth - 14, 12, { align: "right" });

  // Top-right header: "Meter No.: " in black, serial number in red
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  const labelText = "Meter No.: ";
  const labelWidth = doc.getTextWidth(labelText);
  const fullLineWidth = doc.getTextWidth(`Meter No.: ${meterSerialNo}`);
  const lineStartX = pageWidth - 14 - fullLineWidth;
  doc.setTextColor(0, 0, 0);
  doc.text(labelText, lineStartX, 20);
  doc.setTextColor(220, 0, 0);
  doc.text(meterSerialNo, lineStartX + labelWidth, 20);
  doc.setTextColor(0, 0, 0);

  const unitLabel = showLiters ? "(l)" : "(units)";

  const body = results.map((row) => [
    getPreviousMonthYear(row.cutoffDateTime),
    formatDate(row.cutoffDateTime),
    row.previousReading !== null && row.previousReading !== undefined
      ? formatVolume(row.previousReading, showLiters)
      : "--",
    formatVolume(row.reading, showLiters),
    formatVolume(row.consumption, showLiters),
  ]);

  autoTable(doc, {
    head: [[
      "Period",
      "Cut-off Timestamp",
      `Previous Month Rd. ${unitLabel}`,
      `End Of Month Reading ${unitLabel}`,
      `Monthly Consumption ${unitLabel}`,
    ]],
    body,
    startY: 25,
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [0, 0, 0],
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      lineWidth: 0.3,
      lineColor: [0, 0, 0],
    },
  });

  doc.save(`monthly-report-${meterSerialNo}.pdf`);
}
